import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

/**
 * TranslateLoader qui lit le dictionnaire depuis `window.Dic` injecté par `message.js`.
 * Transforme `{ clé: { text, width, fmt } }` en `{ clé: "texte" }` pour ngx-translate.
 */
export class DicTranslateLoader implements TranslateLoader {
	getTranslation(_lang: string): Observable<Record<string, string>> {
		const dic = window.Dic ?? {};
		const translations: Record<string, string> = {};
		for (const key of Object.keys(dic)) {
			translations[key] = dic[key].text;
		}
		return of(translations);
	}
}
